import React from "react";
import { useLocation } from "react-router-dom";
import Paso4 from "../../components/CotizacionHogar/CotizacionValoresPaso4";
import Paso4HogarAig from "../../components/CotizacionHogar/CotizacionValoresPaso4HogarAig";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ContainerCotizacionPaso4 = () => {
  const query = useQuery();
  const producto = query.get("producto");

  const Paso4Component =
    producto === "hogar-aig" ? Paso4HogarAig : Paso4;

  return (
    <main className="bg-light">
      <div className="cr-content container-fluid">
        <div className="container-body-spaces">
          <Paso4Component />
        </div>
      </div>
    </main>
  );
};

export default ContainerCotizacionPaso4;
